export default __webpack_public_path__ + "static/media/33.91fe206f.jpeg";